import { useState } from "react";
import { billing } from "@/lib/billing";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, BadgePercent, Check } from "lucide-react";

export const PRO_BENEFITS = [
  "Vedi integralmente le richieste compatibili",
  "Ricevi notifiche delle nuove richieste",
  "Invia offerte e proposte ai clienti",
  "Attiva \"Disponibile ora\" senza limiti",
  "Chat, gestione lavori e recensioni",
  "0% commissioni: quello che guadagni resta a te",
];

export function PlanSelector({ compact = false }) {
  const [loading, setLoading] = useState(null);

  const startCheckout = async (plan) => {
    setLoading(plan);
    try {
      const { data } = await billing.post("/subscription/checkout", { plan, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Impossibile avviare il pagamento");
      setLoading(null);
    }
  };

  return (
    <div className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2"}`}>
      <div className="bg-white rounded-3xl border border-slate-200 p-5 space-y-3" data-testid="plan-monthly">
        <p className="font-heading font-semibold text-slate-900">Mensile</p>
        <p className="font-heading text-3xl font-bold text-slate-900">€9,90<span className="text-base font-semibold text-slate-500">/mese</span></p>
        <p className="text-xs text-slate-500">Rinnovo automatico mensile. Disdici quando vuoi.</p>
        <Button data-testid="subscribe-monthly-btn" onClick={() => startCheckout("monthly")} disabled={!!loading} variant="outline"
          className="w-full h-12 rounded-full font-semibold active:scale-[0.98] transition-transform">
          {loading === "monthly" ? <Loader2 className="w-5 h-5 animate-spin" /> : "Attiva WhooNow Pro"}
        </Button>
      </div>

      <div className="relative bg-white rounded-3xl border-2 border-whoo p-5 space-y-3 shadow-lg shadow-orange-500/10" data-testid="plan-yearly">
        <span className="absolute -top-3 left-5 bg-whoo text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1">
          <BadgePercent className="w-3.5 h-3.5" /> Miglior valore
        </span>
        <p className="font-heading font-semibold text-slate-900 pt-1">Annuale</p>
        <p className="font-heading text-3xl font-bold text-slate-900">€79,90<span className="text-base font-semibold text-slate-500">/anno</span></p>
        <p className="text-xs font-semibold text-emerald-600">Risparmia circa il 33% rispetto a 12 mensilità (€118,80)</p>
        <Button data-testid="subscribe-yearly-btn" onClick={() => startCheckout("yearly")} disabled={!!loading}
          className="w-full h-12 rounded-full bg-whoo hover:bg-whoo-dark text-white font-heading font-semibold active:scale-[0.98] transition-transform">
          {loading === "yearly" ? <Loader2 className="w-5 h-5 animate-spin" /> : "Attiva WhooNow Pro"}
        </Button>
      </div>

      {!compact && (
        <ul className="sm:col-span-2 space-y-2 pt-2">
          {PRO_BENEFITS.map((b) => (
            <li key={b} className="flex items-start gap-2 text-sm text-slate-700">
              <Check className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" /> {b}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
